import { render, staticRenderFns } from "./DFieldTextarea.vue?vue&type=template&id=3f396d54&"
import script from "./DFieldTextarea.vue?vue&type=script&lang=js&"
export * from "./DFieldTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DFieldTextarea.vue?vue&type=style&index=0&id=3f396d54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports